import {
  browserName,
  osName,
  browserVersion,
  osVersion,
  deviceType,
  fullBrowserVersion
} from 'react-device-detect';
import { BrowserDetails } from '../pages/Session';

export const getBrowserDetails = (): BrowserDetails => {
  const browser = {
    browserName,
    osName,
    browserVersion,
    osVersion,
    deviceType,
    fullBrowserVersion
  };

  if (osName === 'Windows' && osVersion === '10') {
    browser.osVersion = '10/11';
  }

  return browser;
};
